const form = document.getElementById('form');
const confirmModal = document.getElementById('modal');
const modalBg = document.getElementById('modal-bg');
const modalBack = document.getElementById('back');
const yourName = document.getElementById('your-name');
const yourMail = document.getElementById('your-mail');
const yourTel = document.getElementById('your-tel');
const yourMessage = document.getElementById('your-message');

function adjustHeight(textarea) {
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
}

form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (form.checkValidity()) {
        yourName.value = document.getElementById('name').value;
        yourMail.value = document.getElementById('mail').value;
        yourTel.value = document.getElementById('tel').value;
        yourMessage.value = document.getElementById('message').value;
        confirmModal.classList.add('open');
        modalBg.classList.add('open');
        adjustHeight(yourMessage);
    }
});

modalBack.addEventListener('click', () => {
    confirmModal.classList.remove('open');
    modalBg.classList.remove('open');
});